import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { GeneralService } from 'src/app/shared/services/general.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'usersManagerCompoment',
    templateUrl: './usersManager.component.html',
    styleUrls: ['./usersManager.component.scss']    
})
export class UsersManagerComponent implements OnInit{

    dialogRef: MatDialogRef<any>;
    
    formGroup: FormGroup;
    params:any={};
    list:any = [];
    perfil = [];

    constructor(
        private formBuilder: FormBuilder,
        protected httpService: HttpService,
        protected gs: GeneralService,
        public dialog: MatDialog
    ){
        
        this.perfil = this.gs.getGeneralData('perfil');
    }

    ngOnInit(){
        
        this.formGroup = this.formBuilder.group({
            perfil_id: ['2', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    save(){
        if(!this.params?.id)
            return;
             
        this.httpService.put<any>(API.person.general.companyuser,{
            "owner_person_id":this.params?.id,
            perfil_id: this.formGroup.controls['perfil_id'].value,
            email: this.formGroup.controls['email'].value
        }).then(result => {
            this.formGroup.reset();
            this.gs.message('Usuário adicionado com sucesso');
            this.gs.transactionData.next({method:'usersManager', action:'new', data:result });
            this.dialogRef.close();
        })
        .catch(err => this.gs.error(err));
    }

    
    toLower(e){
        e.target.value = e.target.value.toLowerCase();
    }
    
}
